import { css } from 'styled-components';

const loaderTransition = {
   start: css`
      opacity: 0;
   `,
   enter: css`
      opacity: 1;
   `,
   exit: css`
      opacity: 0;
   `,
};

export { loaderTransition };
